import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/sections/common/services/api.service';
import { InsuranceCompany } from '../../../../models/auxiliary/insurance-company.model';
import { InsuranceCompanyEndPoints } from 'src/app/constants/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class InsuranceCompanyService {
  insuranceCompanyUrls = InsuranceCompanyEndPoints;

  constructor(private _apiService : ApiService) { }

  private returnResponse(response: any) {
    if (response._statusCode > 399) {
      throw (response);
    }
    return response;
  }

  saveInsuranceCompany(resolutionIssue: InsuranceCompany): Observable<InsuranceCompany> {
    return this._apiService.post(this.insuranceCompanyUrls.save, resolutionIssue, true, true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  updateInsuranceCompany(id: number, resolutionIssue: InsuranceCompany): Observable<InsuranceCompany> {
    return this._apiService.put(this.insuranceCompanyUrls.update + id, resolutionIssue, true, true)
      .pipe(
        map((response: any) => {
          return this.returnResponse(response);
        }));
  }

  deleteInsuranceCompany(id: number): Observable<InsuranceCompany> {
    return this._apiService.delete(this.insuranceCompanyUrls.delete, id.toString(), true).pipe(
        map((response: any) => {
        return this.returnResponse(response);
      }));
  }
}
